import { render, staticRenderFns } from "./FeedbackExpansionPanel.vue?vue&type=template&id=e348cb98"
import script from "./FeedbackExpansionPanel.vue?vue&type=script&lang=ts"
export * from "./FeedbackExpansionPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports